import { Link } from '@solidjs/router';
import { Show } from 'solid-js';
import clsx from 'clsx';
import type { FirstLevelMenuItemLinkProps } from '../../../menu-types';
import { removeTrailingSlash } from '../../../../../tools/remove-trailing-slash';
import removeAmpersand from '../../../../../tools/remove-ampersand';
import urlMatches from '../../../../../tools/url-match';
import { isExternalLink } from '../../../../../tools/check-is-external-url';

export const FirstLevelMenuItemLink = (props: FirstLevelMenuItemLinkProps) => {
    const isActive = () => urlMatches(props.link.url);

    return (
        <Link
            href={removeTrailingSlash(props.link.url)}
            onClick={() => props.onLinkClick()}
            class={clsx(
                'flex items-center gap-cvi-5 min-h-cvi-touch-min p-cvi-4 label-lg text-cvi-fg-default no-underline transition-colors duration-200 hover:text-cvi-fg-link',
                isActive() ? 'font-cvi-bold' : 'font-cvi-medium'
            )}
            {...(isExternalLink(props.link.url)
                ? {
                    target: '_blank',
                    rel: 'noopener noreferrer',
                }
                : {})}
        >
            <Show when={isActive()}>
                <span
                    aria-hidden="true"
                    class="size-cvi-3 rounded-cvi-round bg-cvi-fg-brand shrink-0"
                />
            </Show>
            {props?.icon}
            {removeAmpersand(props.link.title)}
        </Link>
    );
};
